
import React, { useContext } from "react";
import { FaLeaf, FaGlobeAmericas, FaRecycle, FaWater } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ComplianceGlobal.css';
import BannerImage from './compliance_hero.png';

function ISO14K1Comp() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/iso-14001-compliance');
    } else {
      navigate('/login', { state: { from: '/booking/iso-14001-compliance' } });
    }
  };

  return (
    <div className="compliance-page">
      <div className="compliance-max-width">

        {/* --- HERO --- */}
        <div className="compliance-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Environmental Management</span>
          <h1 className="hero-title">ISO 14001 Compliance</h1>
          <p className="hero-subtitle">
            Commitment to a sustainable future. Minimizing environmental footprint
            while maximizing operational efficiency.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Get Complied <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">The Green Standard</h2>
              <p className="article-text">
                ISO 14001 sets the criteria for an Environmental Management System (EMS). It provides a framework
                that a company or organization can follow to set up an effective environmental management system.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Plan-Do-Check-Act (PDCA)</h2>
              <p className="article-text">
                Like other ISO standards, ISO 14001 follows the PDCA cycle.
                <br /><strong>Plan:</strong> Establish environmental objectives.
                <br /><strong>Do:</strong> Implement processes.
                <br /><strong>Check:</strong> Monitor and measure processes against policies.
                <br /><strong>Act:</strong> Take actions to improve performance continually.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Strategic Benefits</h2>
              <p className="article-text">
                Compliance reduces cost of waste management, saves energy, and improves corporate image.
                It is increasingly becoming a requirement for tendering in global markets.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">Eco-Focus Areas</h4>
              <ul className="key-list">
                <li><FaLeaf className="check-icon" /> Carbon Footprint</li>
                <li><FaWater className="check-icon" /> Water Conservation</li>
                <li><FaRecycle className="check-icon" /> Waste Management</li>
                <li><FaGlobeAmericas className="check-icon" /> Sustainable Sourcing</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Go Green</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Achieve ISO 14001 compliance.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default ISO14K1Comp;
